import { render } from "./InFlightOrdersNotice.vue?vue&type=template&id=ad96808e&scoped=true"
import script from "./InFlightOrdersNotice.vue?vue&type=script&lang=js"
export * from "./InFlightOrdersNotice.vue?vue&type=script&lang=js"

import "./InFlightOrdersNotice.vue?vue&type=style&index=0&id=ad96808e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad96808e"]])

export default __exports__